export const normalizeCurrency = (currency) => (currency === "EUR" ? "EUR" : "PLN");

/** Cena widoczna w sklepie (promo lub regularna) w wybranej walucie. */
export const getProductOfferPrice = (product, currency = "PLN") => {
  if (!product) {
    return { price: undefined, currency: normalizeCurrency(currency) };
  }

  const c = normalizeCurrency(currency);
  const hasPromo = Boolean(product.promo_percentage);

  if (c === "EUR") {
    const price = hasPromo
      ? product.promo_price_EUR ?? product.EUR
      : product.EUR;
    return { price, currency: "EUR" };
  }

  const price = hasPromo
    ? product.promo_price_PLN ?? product.PLN
    : product.PLN;
  return { price, currency: "PLN" };
};

export const buildProductOfferSchema = (product, currency = "PLN", url) => {
  const { price, currency: priceCurrency } = getProductOfferPrice(product, currency);

  const offer = {
    "@type": "Offer",
    priceCurrency,
  };

  if (url) {
    offer.url = url;
  }

  if (price !== undefined && price !== null && price !== "") {
    offer.price = price;
  }

  if (product.quantity !== undefined && product.quantity !== null) {
    offer.availability =
      Number(product.quantity) > 0
        ? "https://schema.org/InStock"
        : "https://schema.org/OutOfStock";
  }

  return offer;
};
